import DoctorCards from 'src/components/Cards/DoctorsCards';
import Heading from 'src/components/Heading/Heading';
import { Accordion } from '@get-mosh/msh-shared';
import { Card as CardType } from 'src/types/Card';
import doctorsData from '../../data/doctors.json';
import classNames from 'classnames';
import { AccordionItemProps } from '@get-mosh/msh-shared/dist/src/components/Accordion/AccordionItem';

export type OurDoctorsProps = {
    doctors: CardType[];
    title: string;
    className?: string;
    accordion?: AccordionItemProps[];
    backgroundColor?: string;
};

const OurDoctors = ({
    doctors,
    title,
    className,
    accordion = doctorsData.doctorsFaq,
    backgroundColor = 'bg-sand-light',
}: OurDoctorsProps) => {
    return (
        <div
            className={classNames(
                'container mx-auto lg:min-h-[400px]',
                className,
            )}
        >
            <div
                className={classNames(
                    'mb-8',
                    doctors.length === 1 && 'lg:mx-auto lg:max-w-xl',
                )}
            >
                <Heading centered={true} tag="p" level="h2">
                    {title}
                </Heading>
            </div>
            <div
                className={classNames(
                    'grid items-center',
                    doctors.length === 1
                        ? 'md:grid-cols-2 md:gap-x-8'
                        : 'grid items-center lg:grid-cols-2 lg:gap-x-8',
                )}
            >
                <DoctorCards cards={doctors} />
                <Accordion
                    className="!border-0"
                    itemClassName={backgroundColor}
                    items={accordion}
                />
            </div>
        </div>
    );
};

export default OurDoctors;
